<template>
  <div class="vue-searchbox">
    <div class="search-box store-search-box">
      <form action="/search" method="get" id="small-search-box-form">
        <!-- the input field -->
        <input
          type="text"
          class="search-box-text"
          id="small-searchterms"
          autocomplete="off"
          name="q"
          placeholder="Zoek op reeks, uitgever, titel of tekenaar/scenarist"
          aria-label="Zoeken"
          v-model="query"
          @keydown.down="down"
          @keydown.up="up"
          @keydown.enter="hit"
          @keydown.esc="reset"
          @input="debounce(250)"
          @blur="hideDropdown"
        />

        <input type="submit" class="button-1 search-box-button" value />

        <!-- <img src="\Themes\Striep2\Content\svg\search.svg" id="submit-search" /> -->
      </form>
      <!-- the list -->
      <ul class="dropdown-autocomplete" v-show="hasItems && query && !dropdownHidden">
        <template
          v-for="item in items"
          :class="activeClass($item)"
          @mouseDown="hit(item)"
          @mousemove="setActive($item)"
          v-on:keyup.page-down="down"
          v-on:keyup.page-up="up"
        >
          <li @mouseDown="hit(item)" v-bind:key="item.id">
            <a @mouseDown="hit(item)" :href="item.url">{{item.name}}</a>
          </li>
        </template>
      </ul>
      <div class="header-menu"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "search-bar-component",
  data: function () {
    return {
      items: [],
      query: "",
      current: -1,
      loading: false,
      selectFirst: false,
      queryParamName: "keyword",
      dropdownHidden: true,
      timeoutId: null
    };
  },
  computed: {
    hasItems() {
      return this.items != null && this.items.length > 0;
    },

    isEmpty() {
      return !this.query;
    },

    isDirty() {
      return !!this.query;
    },
  },
  mounted() {
    // document.querySelector('#small-searchterms').onfocus = function() {
    //   console
    //     this.dropdownHidden = true;
    //   }
    // document.querySelector('#small-searchterms').onblur = function() {
    //   document.querySelector('.dropdown-autocomplete').style.display = "none";
    // }
    // document.querySelector('#small-searchterms').onfocus = function() {
    //   document.querySelector('.dropdown-autocomplete').style.display = "initial";
    // }
  },
  methods: {
    hideDropdown() {
      // setTimeout(() => { this.dropdownHidden = true; }, 250);
      setTimeout(function () {
        this.dropdownHidden = true;
      }.bind(this), 250)
    },
    debounce(debounceDuration = 300){
        if(this.timeoutId !== null)
        {
            clearTimeout(this.timeoutId);
        }
        this.timeoutId = setTimeout(() => {
            this.update();
        }, debounceDuration);
    },
    update() {
      this.cancel();

      if (!this.query) {
        return this.reset();
      }

      if (this.minChars && this.query.length < this.minChars) {
        return;
      }

      this.loading = true;

      this.fetch()
        .then((response) => {
          if(response)
            return response.json();
        })
        .then((response) => {
          if (response && this.query) {
            let data = response;
            // data = this.prepareResponseData ? this.prepareResponseData(data) : data
            // this.items = this.limit ? data.slice(0, this.limit) : data ?? []
            this.items = data;
            this.current = -1;
            this.loading = false;

            if (this.selectFirst) {
              this.down();
            }
            this.dropdownHidden = false;
          }
        });
    },

    fetch() {
      let cancel = new Promise((resolve) => (this.cancel = resolve));
      let request = fetch("/autocomplete?keyword=" + this.query);

      return Promise.race([cancel, request]);
    },

    cancel() {
      // used to 'cancel' previous searches
    },

    reset() {
      this.item = {};
      this.query = "";
      this.loading = false;
    },

    setActive(index) {
      this.current = index;
    },

    activeClass(index) {
      return {
        active: this.current === index,
      };
    },

    //hit() {
    //    if (this.current !== -1) {
    //        this.onHit(this.items[this.current])
    //    }
    //},

    up() {
      var dropdownElem = document.querySelector(".dropdown-autocomplete")
        .children;

      if (this.current > 0) {
        this.current--;
        dropdownElem[this.current + 1].classList.remove("active");
      } else {
        if (this.current != -1) {
          dropdownElem[this.current].classList.remove("active");
        }

        this.current = dropdownElem.length - 1;
      }

      dropdownElem[this.current].classList.add("active");
    },

    down() {
      var dropdownElem = document.querySelector(".dropdown-autocomplete")
        .children;

      if (this.current < dropdownElem.length - 1) {
        this.current++;
        if (this.current != 0) {
          dropdownElem[this.current - 1].classList.remove("active");
        }
      } else {
        dropdownElem[this.current].classList.remove("active");
        this.current = 0;
      }

      dropdownElem[this.current].classList.add("active");
    },

    hit(event) {
      event.preventDefault();

      if (!this.current || !this.items[this.current])
        window.location.href = "/search?q=" + this.query;

      let url = this.items[this.current].url;
      window.location.href = url;
    },
  },
};
</script>